"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DocumentItem = void 0;
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _Localization = require("../../Localization");
var _defaultTranslations_simplifiedRegistrationBrandPartner = require("../../constants/defaultTranslations_simplified-registration-BrandPartner");
var _models = require("../../models");
var _ConfirmDeleteDialog = require("../ConfirmDeleteDialog");
var _ThumbWithDetail = require("../ThumbWithDetail");
var _DocumentItemFile = require("./DocumentItemFile");
var _DocumentItemStyledComponents = require("./DocumentItemStyledComponents");
var _jsxRuntime = require("react/jsx-runtime");
const DocumentItem = props => {
  const {
    onDocumentRemove,
    document,
    isShowApprovalState,
    canDelete,
    errorMessage,
    isDeleteConfirmationRequired,
    uploadProgress
  } = props;
  const [confirmOpened, setConfirmOpened] = (0, _react.useState)(false);
  const {
    getTestIdProps
  } = (0, _testidGenerator.default)();
  const confirmDelete = () => setConfirmOpened(true);
  const confirmCanceled = () => setConfirmOpened(false);
  const removeDocument = () => {
    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions -- TODO we must fixed and checked correct working in separate story
    if (onDocumentRemove && document.documentId) {
      onDocumentRemove(document.documentId);
    }
  };
  const deleteDocument = () => {
    if (onDocumentRemove) {
      onDocumentRemove(document.documentId);
    }
    setConfirmOpened(false);
  };
  const getDeleteButton = () => {
    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions -- can be falsy
    const deleteAction = errorMessage ?? !isDeleteConfirmationRequired ? removeDocument : confirmDelete;
    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions -- TODO we must fixed and checked correct working in separate story
    if (canDelete ?? errorMessage) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_DocumentItemStyledComponents.StyledDeleteIcon, {
        onClick: deleteAction,
        ...getTestIdProps('document-item-btn-delete')
      });
    }
    return null;
  };
  const getProgressBar = () => {
    if (typeof uploadProgress === 'number') {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_DocumentItemStyledComponents.StyledProgress, {
        value: uploadProgress,
        variant: "determinate"
      });
    }
    return null;
  };
  const getThumb = () => {
    const {
      fileName,
      documentId
    } = document;
    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions -- TODO we must fixed and checked correct working in separate story
    if (fileName && documentId) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_ThumbWithDetail.ThumbWithDetail, {
        fileName: fileName,
        documentId: documentId
      });
    }
    return null;
  };
  const getError = () => {
    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions -- TODO we must fixed and checked correct working in separate story
    if (errorMessage) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Tooltip, {
        title: errorMessage,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_DocumentItemStyledComponents.StyledErrorIcon, {})
      });
    }
    return null;
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_DocumentItemStyledComponents.StyledListItem, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_DocumentItemStyledComponents.StyledDivContent, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_DocumentItemStyledComponents.StyledSpanInfo, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_DocumentItemStyledComponents.StyledSpanThumb, {
          children: getThumb()
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_DocumentItemFile.DocumentItemFile, {
          document: document,
          visibleApprovalState: isShowApprovalState
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_DocumentItemStyledComponents.StyledSpanActions, {
        children: [getError(), getDeleteButton()]
      })]
    }), getProgressBar(), /*#__PURE__*/(0, _jsxRuntime.jsx)(_ConfirmDeleteDialog.ConfirmDeleteDialog, {
      opened: confirmOpened,
      handleCancel: confirmCanceled,
      handleConfirm: deleteDocument,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
        paragraph: true,
        align: "center",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
          id: _models.TranslationKey.confirmDocumentDelete,
          defaultMessage: _defaultTranslations_simplifiedRegistrationBrandPartner.defaultTranslations.confirmDocumentDelete
        })
      })
    })]
  });
};
exports.DocumentItem = DocumentItem;